  import { useState, useRef, useEffect, useMemo } from "react";
  import { useOutletContext,useNavigate } from "react-router-dom";
  import { FaTrash, FaBuilding , FaLocationArrow,FaUniversity,FaTruck, FaBoxOpen,FaPen, FaSearch,FaSave,
  FaPaperPlane,
  FaPrint,
  FaTimes } from "react-icons/fa";
  import DatePicker from "react-datepicker";
  import "react-datepicker/dist/react-datepicker.css";
  import "../styles/SalesInvoice.css";
  import { loadData, saveData } from "../api/connector";
  import * as services from "../api/services";


  export default function SalesInvoice() {
    const { collapsed } = useOutletContext();
    // ================= INVOICE =================
    const [manualEntry, setManualEntry] = useState(false);
    const [invoiceNo, setInvoiceNo] = useState("");
    const [customer,setCustomer] = useState({});
    const [invoiceDate, setInvoiceDate] = useState(new Date());
    const [orderDate, setOrderDate] = useState(new Date());
    const [dispatchDate, setDispatchDate] = useState(new Date());
    const [dispatch, setDispatch] = useState({ ewayBill: "", transporter: "", vehicle: "", lr: "", mode: "" });
    const [shippingDate, setshippingDate] = useState(new Date());
    // ================= TYPE + ECO =================
    const [typeOfSupply, setTypeOfSupply] = useState("");
    // NEW STATES
    const [invoiceType, setInvoiceType] = useState("item"); // item | accounting
    const [rcmApplicable, setRcmApplicable] = useState(false);

    const [openGroupDropdown, setOpenGroupDropdown] = useState(false);
    const [customers, setCustomers] = useState([]);
    const [itemsList, setItemsList] = useState([]);
    const [salesmen, setSalesmen] = useState([]);
    const [salesman, setSalesman] = useState("");
    const [orders, setOrders] = useState([]);
    const [orderNo, setOrderNo] = useState("");
    const [customerSearch, setCustomerSearch] = useState("");
    const [showCustomerDropdown, setShowCustomerDropdown] = useState(false);

    const [ledger, setLedger] = useState({
      gstin: "",
      name: "",
      address1: "",
      address2: "",
      state: "",
      group: "Sundry Debtors"   // ✅ ALWAYS DEFAULT
    });

    const [groupList, setGroupList] = useState([]);
    useEffect(() => {
    const savedGroups = JSON.parse(localStorage.getItem("ledgerGroups")) || [];

    setGroupList(savedGroups);

    // ✅ ensure default always set
    setLedger((prev) => ({
      ...prev,
      group: prev.group || "Sundry Debtors"
    }));
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const [custRes, itemRes, vendRes, ordRes] = await Promise.all([
          services.getParties({ type: "customer" }),
          services.getItems({}),
          services.getParties({ type: "vendor" }),
          services.getSaleOrders({})
        ]);
        const cust = Array.isArray(custRes.data) ? custRes.data : custRes.data?.results ?? [];
        const itm = Array.isArray(itemRes.data) ? itemRes.data : itemRes.data?.results ?? [];
        const vend = Array.isArray(vendRes.data) ? vendRes.data : vendRes.data?.results ?? [];
        const ord = Array.isArray(ordRes.data) ? ordRes.data : ordRes.data?.results ?? [];
        setCustomers(cust);
        setItemsList(itm);
        setSalesmen(vend);
        setOrders(ord);
      } catch (e) {
        console.error("Failed to load customers/items:", e);
      }
    })();
  }, []);

  const handleOrderChange = (value) => {
    setOrderNo(value);
    const order = orders.find((o) => o.order_number === value);
    if (order?.date) {
      try {
        setOrderDate(new Date(order.date));
      } catch {
        setOrderDate(new Date());
      }
    }
  };

  const fetchGSTDetails = async (gstin) => {
  if (gstin.length !== 15) return;
  try {
    const res = await services.lookupGst(gstin);
    const data = res.data;
    setLedger((prev) => ({
      ...prev,
      name: data.company_name || "",
      address1: data.address || "",
      address2: data.branch_address || "",
      state: data.state || ""
    }));
  } catch (err) {
    console.log("GST Fetch Error:", err);
  }
};

    // ================= ITEMS =================
    const [items, setItems] = useState([
      { description: "", itemId: null, hsn: "", qty: "", rate: "", discount: "", tax: "", amount: "" }
    ]);
    const ecoRef = useRef(null);
    // ================= CUSTOMER =================
  const [billedTo, setBilledTo] = useState({
      name: "",
      address: "",
      city: "",
      contact: "",
      mobile: "",
      pan: "",
      gstin: "",
      pos: ""
    });

    const [shippedTo, setShippedTo] = useState({
      name: "",
      address: "",
      city: "",
      contact: "",
      mobile: "",
      pan: "",
      gstin: "",
      pos: ""
    });
    // const [shippedTo, setShippedTo] = useState({ ...billedTo });

    const [ecoOptions, setEcoOptions] = useState([
    "Amazon",
    "Flipkart",
    "Meesho",
    "Blinkit"
    ]);

    const states = [
  "Andhra Pradesh","Arunachal Pradesh","Assam","Bihar","Chhattisgarh",
  "Goa","Gujarat","Haryana","Himachal Pradesh","Jharkhand",
  "Karnataka","Kerala","Madhya Pradesh","Maharashtra","Manipur",
  "Meghalaya","Mizoram","Nagaland","Odisha","Punjab","Rajasthan",
  "Sikkim","Tamil Nadu","Telangana","Tripura","Uttar Pradesh",
  "Uttarakhand","West Bengal"
];
const [openStateDropdown, setOpenStateDropdown] = useState(false);
const [selectedState, setSelectedState] = useState("");

    const deleteRow = (index) => {
    const updated = items.filter((_, i) => i !== index);
    setItems(updated.length ? updated : [{
      description: "",
      itemId: null,
      hsn: "",
      qty: "",
      rate: "",
      discount: "",
      tax: "",
      amount: ""
    }]);
  };
    const [showInvoiceSettings, setShowInvoiceSettings] = useState(false);
    const [registrationType, setRegistrationType] = useState("E-commerce operator");

  const [invoiceConfig, setInvoiceConfig] = useState({
    prefix: "Tax/2025-26",
    zero: '',
    start: '',
    manual_pre: false
  });
  const [voucherCount, setVoucherCount] = useState(1);
  const generateVoucher = () => {
    const number = String(voucherCount).padStart(2, "0");
    return `SAL-${number}`;
  };
  /* ==================== API HELPERS ==================== */
  const mapSupplyType = (t) => {
    if (t === "SEZ") return "SEZ";
    if (t && t.indexOf("Export") === 0) return "EXPORT";
    return "REGULAR";
  };

  const mapRegistrationToGstType = (reg) => {
    const r = (reg || "").toLowerCase();
    if (r.includes("composition")) return "REGISTERED_BUSINESS_COMPOSITION";
    if (r.includes("regular") || r.includes("sez") || r.includes("export") || r.includes("e-commerce") || r.includes("distributor")) return "REGISTERED_BUSINESS_REGULAR";
    return "UNREGISTERED";
  };

  const blankAddress = () => ({
    name: "", address: "", city: "", contact: "", mobile: "", pan: "", gstin: "", pos: ""
  });

  const selectCustomer = (cust) => {
    setCustomer(cust);
    setCustomerSearch(cust.name);
    setShowCustomerDropdown(false);
    const billed = {
      name: cust.name || "",
      address: cust.billing_address || "",
      city: "",
      contact: cust.contact || "",
      mobile: cust.phone || "",
      pan: cust.pan || "",
      gstin: cust.gstin || "",
      pos: cust.state || ""
    };
    setBilledTo(billed);
    setShippedTo({ ...billed });
  };

  const filteredCustomers = useMemo(() => {
    const q = customerSearch.trim().toLowerCase();
    if (!q) return customers;
    return customers.filter((c) =>
      (c.name || "").toLowerCase().includes(q) ||
      (c.gstin || "").toLowerCase().includes(q)
    );
  }, [customers, customerSearch]);

  const isValidGST = (gst) => {
    const regex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[A-Z0-9]{1}Z[A-Z0-9]{1}$/;
    return regex.test(gst);
  };

  const fetchGstForCustomer = async () => {
    const gstin = (customer.gstin || "").trim().toUpperCase();
    if (!isValidGST(gstin)) {
      alert("Invalid GSTIN");
      return;
    }
    try {
      const res = await services.lookupGst(gstin);
      const data = res.data;
      if (data.success) {
        setCustomer((prev) => ({
          ...prev,
          gstin: data.gstin || gstin,
          name: data.company_name || prev.name,
          address1: data.address || prev.address1,
          address2: data.branch_address || prev.address2,
          email: data.email || prev.email,
          contact: data.contact_person || prev.contact,
          mobile: data.contact_no || prev.mobile,
          state: data.state || prev.state
        }));
        if (data.state) setSelectedState(data.state);
      } else {
        alert("GST not found");
      }
    } catch (error) {
      console.error(error);
      alert("GST lookup failed: " + (error.response?.data?.detail || error.message));
    }
  };

  const saveCustomer = async () => {
    if (!customer.name || !customer.name.trim()) { alert("Party Name required"); return; }
    const pan = (customer.pan || "").trim().toUpperCase();
    if (pan && !/^[A-Z]{5}[0-9]{4}[A-Z]$/.test(pan)) { alert("Invalid PAN: must be 10 characters (e.g. ABCDE1234F)"); return; }
    const gstin = (customer.gstin || "").trim().toUpperCase();
    if (gstin && !isValidGST(gstin)) { alert("Invalid GSTIN"); return; }
    try {
      const res = await services.createParty({
        name: customer.name.trim(),
        party_type: "CUSTOMER",
        gstin,
        phone: customer.contact || "",
        email: customer.email || "",
        pan,
        state: customer.state || "",
        billing_address: [customer.address1, customer.address2, customer.pin].filter(Boolean).join(", "),
        gst_type: mapRegistrationToGstType(customer.registration)
      });
      const created = res.data;
      setCustomers((prev) => [...prev, created]);
      selectCustomer(created);
      setShowCustomerPopup(false);
      alert("Customer created successfully!");
    } catch (err) {
      const data = err.response?.data;
      const msg =
        (typeof data === "string" && data) ||
        (Array.isArray(data) && data[0]) ||
        data?.detail ||
        data?.name?.[0] ||
        err.message ||
        "Failed to save customer";
      alert(msg);
    }
  };

  const resetForm = () => {
    setItems([{ description: "", itemId: null, hsn: "", qty: "", rate: "", discount: "", tax: "", amount: "" }]);
    setCustomer({});
    setCustomerSearch("");
    setShowCustomerDropdown(false);
    setBilledTo(blankAddress());
    setShippedTo(blankAddress());
    setSalesman("");
  };

  const handleSave = async (mode = "save") => {
    const r2 = (n) => Math.round(n * 100) / 100;
    const line = (i) => {
      const tax = rcmApplicable ? 0 : Number(i.tax) || 0;
      let base, qty, rate, discount;
      if (invoiceType === "item") {
        qty = Number(i.qty) || 0;
        rate = Number(i.rate) || 0;
        discount = Number(i.discount) || 0;
        base = qty * rate - discount;
      } else {
        qty = 0; rate = 0; discount = 0;
        base = Number(i.amount) || 0;
      }
      const gst = (base * tax) / 100;
      let igst = 0, cgst = 0, sgst = 0;
      if (typeOfSupply === "Outward") { cgst = gst / 2; sgst = gst / 2; }
      if (typeOfSupply === "Export_with_payment" || typeOfSupply === "SEZ") { igst = gst; }
      return {
        item: i.itemId || null,
        mrp: r2(rate),
        quantity: qty,
        unit: "NONE",
        price: r2(rate),
        price_type: "WITHOUT_TAX",
        discount_percentage: qty * rate > 0 ? Math.min(999.99, Number(((discount * 100) / (qty * rate)).toFixed(2))) : 0,
        discount_amount: r2(discount),
        taxable_value: r2(base),
        gst_rate: tax,
        cgst: r2(cgst),
        sgst: r2(sgst),
        igst: r2(igst),
        cess: 0,
        amount: r2(base + gst)
      };
    };

    const lines = items.map(line);
    const subtotal = lines.reduce((s, l) => s + l.taxable_value, 0);
    const totalCgst = lines.reduce((s, l) => s + l.cgst, 0);
    const totalSgst = lines.reduce((s, l) => s + l.sgst, 0);
    const totalIgst = lines.reduce((s, l) => s + l.igst, 0);
    const totalBeforeRound = subtotal + totalCgst + totalSgst + totalIgst;
    const roundOff = r2(Math.round(totalBeforeRound) - totalBeforeRound);
    const grandTotal = r2(totalBeforeRound + roundOff);

    const payload = {
      voucher_number: invoiceNo || generateInvoice(),
      date: invoiceDate.toISOString().split("T")[0],
      bill_date: invoiceDate.toISOString().split("T")[0],
      party: customer?.id || null,
      state_of_supply: billedTo?.pos?.split("-")[1] || customer?.state || "",
      supply_type: mapSupplyType(typeOfSupply),
      billing_address: [billedTo?.name, billedTo?.address, billedTo?.city].filter(Boolean).join(", "),
      shipping_address: [shippedTo?.name, shippedTo?.address, shippedTo?.city].filter(Boolean).join(", "),
      payment_type: { type: invoiceType, rcm: rcmApplicable },
      round_off_amount: roundOff,
      total_taxable_amount: subtotal,
      total_cgst: totalCgst,
      total_sgst: totalSgst,
      total_igst: totalIgst,
      total_cess: 0,
      total_amount: grandTotal,
      paid: 0,
      balance: grandTotal,
      description: "",
      eway_bill_no: dispatch?.ewayBill || "",
      transporter_name: dispatch?.transporter || "",
      vehicle_no: dispatch?.vehicle || "",
      lr_rr_no: dispatch?.lr || "",
      mode_of_transport: dispatch?.mode || "",
      items: lines
    };
    try {
      await saveData(services.createSalesInvoice, payload,
        async (data) => {
          alert("Invoice saved successfully!");
          setCurrentCount((prev) => prev + 1);
          setVoucherCount((prev) => prev + 1);
          if (mode === "send") {
            try {
              await services.postSalesInvoice(data.id);
              alert("Invoice posted & sent successfully!");
            } catch (e) {
              alert("Invoice saved but posting failed.");
            }
          }
          resetForm();
        },
        (err) => {
          const data = err?.response?.data || err;
          const msg =
            (typeof data === "string" && data) ||
            (Array.isArray(data) && data[0]) ||
            data?.detail ||
            data?.non_field_errors?.[0] ||
            JSON.stringify(data);
          alert(msg || "Failed to save invoice");
        }
      );
    } catch (e) { console.error(e); }
  };
  const [gstin, setGstin] = useState("");
const [gstData, setGstData] = useState(null);
const [gstLoading, setGstLoading] = useState(false);
const [gstError, setGstError] = useState("");
const [showCustomerPopup, setShowCustomerPopup] = useState(false);

const navigate = useNavigate();
const validateGST = async (value) => {
  if (value.length !== 15) return;

  try {
    setGstLoading(true);
    setGstError("");
    setGstData(null);

    const res = await services.lookupGst(value);
    setGstData(res.data);
  } catch (err) {
    setGstError("Error validating GSTIN");
  } finally {
    setGstLoading(false);
  }
};
const handleGSTChange = (e) => {
  const value = e.target.value.toUpperCase();

  setGstin(value);

  if (value.length === 15) {
    validateGST(value);
  } else {
    setGstData(null);
    setGstError("");
  }
};
  const [currentCount, setCurrentCount] = useState(1);
  // const generateInvoice = () => {
  //   const { prefix, zero } = invoiceConfig;

  //   const zeroCount = Number(zero) || 0;   // convert HERE only
  //   const zeros = "0".repeat(zeroCount);
  //   const number = zeros + String(currentCount);
  //   return `${prefix}/${number}`;
  // };
  const generateInvoice = () => {
  const { prefix, zero } = invoiceConfig;
  const zeroCount = Number(zero) || 0;
  let number = String(currentCount);
  // 🔥 final output ALWAYS 4 digit
  const totalLength = zeroCount + number.length;
  if (totalLength > 4) {
    // trim number from left
    number = number.slice(0, 4 - zeroCount);
  }
  // pad remaining
  const finalNumber = "0".repeat(zeroCount) + number;
  return `${prefix}/${finalNumber}`;
};
  useEffect(() => {
  if (!manualEntry) {
    setInvoiceNo(generateInvoice());
  }
}, [currentCount, invoiceConfig, manualEntry]);

  // load existing invoices so new invoice numbers don't collide
  useEffect(() => {
    (async () => {
      try {
        const res = await services.getSalesInvoices({});
        const invoices = Array.isArray(res.data) ? res.data : res.data?.results ?? [];
        const prefix = invoiceConfig.prefix + "/";
        const nums = invoices
          .map((v) => v.voucher_number || "")
          .filter((v) => v.startsWith(prefix))
          .map((v) => Number(v.replace(prefix, "").replace(/\D/g, "")) || 0);
        const max = nums.length ? Math.max(...nums) : 0;
        setCurrentCount(max + 1);
      } catch (e) {
        console.error("Failed to load existing invoices:", e);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


    const [selectedEco, setSelectedEco] = useState("");
    const [newEco, setNewEco] = useState("");
    const [showEcoEditor, setShowEcoEditor] = useState(false);

    const [editBilled, setEditBilled] = useState(false);
    const [editShipped, setEditShipped] = useState(false);
    const addRow = () => {
    setItems([
      ...items,
      {
        description: "",
        itemId: null,
        hsn: "",
        qty: "",
        rate: "",
        discount: "",
        tax: 0,
        amount: 0
      }
    ]);
  };

  useEffect(() => {
  const handleClickOutside = () => {
    setOpenStateDropdown(false);
  };

  document.addEventListener("click", handleClickOutside);

  return () => {
    document.removeEventListener("click", handleClickOutside);
  };
}, []);

  /* ✅ ADD THIS HERE */
  useEffect(() => {
    if (rcmApplicable) {
      const updated = items.map(item => ({
        ...item,
        tax: 0
      }));
      setItems(updated);
    }
  }, [rcmApplicable]);

  /* YOUR EXISTING USEEFFECT */
    useEffect(() => {
    function handleClickOutside(event) {
      if (ecoRef.current && !ecoRef.current.contains(event.target)) {
        setShowEcoEditor(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
    return (
      <div className="sales-invoice-app">
        <div className={`main-content ${collapsed ? "collapsed" : ""}`}>
          <div className="invoice-wrapper">
            
            
            {/* ================= SALE SECTION ================= */}
            <div className="section-card">
              <div className="sale-header-card">
                <div className="sale-icon">
                  <i className="fas fa-file-invoice"></i>
                </div>
                <div className="sale-info">
                  <h2>Sale Invoice</h2>
                  <div className="voucher-row">
                    <label>Voucher No:</label>
                    <span className="sale-voucher-value">{invoiceNo}</span>
                  </div>
                </div>
              </div>
              <div className="sale-header">
                {/* ================= HEADER ================= */}
                  <div className="invoice-header-section">     
                    <div className="invoice-row">
                      {/* Invoice No */}
                      <div className="invoice-no-group">
                        <label>Invoice No</label>
                        <div className="invoice-input-box">
                          {/* <input
                            value={invoiceNo}
                            onChange={(e) => setInvoiceNo(e.target.value)}
                            placeholder="Tax/2025-26/001"
                            readOnly={!manualEntry}
                          /> */}
                          <input
                            value={invoiceNo}
                            readOnly={!manualEntry}
                            // placeholder="Tax/2025-26/0001"
                            maxLength={16}
                            onChange={(e) => {
                            let value = e.target.value;
                            // 🔥 MANUAL MODE → full freedom
                            if (manualEntry) {
                              setInvoiceNo(value);
                              return;
                            }
                            // 🔥 AUTO MODE → prefix lock
                            const prefix = invoiceConfig.prefix + "/";
                            if (!value.startsWith(prefix)) {
                              value = prefix;
                            }

                            let numberPart = value.replace(prefix, "");
                            numberPart = numberPart.replace(/\D/g, "");
                            numberPart = numberPart.slice(0, 4);

                            value = prefix + numberPart;
                            setInvoiceNo(value);
                          }}
                          />

                          {/* ⚙️ SETTINGS ICON */}
                          <button
                            className="settings-btn"
                            onClick={() => setShowInvoiceSettings(true)}
                          >
                            ⚙️
                          </button>
                        </div>
                      </div>
                      {/* Manual */}
                      <div className="sale-form-group">
                        <label>Invoice Date</label>
                        <DatePicker
                          selected={invoiceDate}
                          onChange={(date) => setInvoiceDate(date)}
                          dateFormat="dd/MM/yyyy"
                          minDate={new Date(new Date().setFullYear(new Date().getFullYear() - 1))} // ✅ last 1 year
                          className="sales-date-input"
                          onChangeRaw={(e) => {
                            if (!e || !e.target) return;
                            let value = e.target.value || "";
                            // allow only numbers + /
                            value = value.replace(/[^0-9/]/g, "");
                            // auto format DD/MM/YYYY
                            if (value.length === 2 || value.length === 5) {
                              if (!value.endsWith("/")) value += "/";
                            }
                            // restrict length
                            if (value.length > 10) {
                              value = value.slice(0, 10);
                            }
                            const parts = value.split("/");
                            // day check
                            if (parts[0] && Number(parts[0]) > 31) parts[0] = "31";
                            // month check
                            if (parts[1] && Number(parts[1]) > 12) parts[1] = "12";
                            // year limit (4 digit)
                            if (parts[2] && parts[2].length > 4) {
                              parts[2] = parts[2].slice(0, 4);
                            }
                            value = parts.join("/");
                            e.target.value = value;
                          }}
                        />
                      </div>
                    </div>
                    {showInvoiceSettings && (
                      <div className="invoice-popup-overlay">
                        <div className="invoice-popup">
                          <h3>Invoice Settings</h3>

                          <div className="popup-group">
                            <label>Manual:</label>
                            <div className="popup-radio">
                              <label>
                                <input
                                  type="radio"
                                  checked={manualEntry}
                                  onChange={() => {
                                    setManualEntry(true);
                                    setInvoiceNo("");   // 🔥 CLEAR INPUT
                                  }}
                                />
                                Yes
                              </label>
                              <label>
                                <input
                                  type="radio"
                                  checked={!manualEntry}
                                  onChange={() => setManualEntry(false)}
                                />
                                No
                              </label>
                            </div>
                          </div>
                          {/* 🔥 MAIN FIX: hide all when manual = true */}
                          {!manualEntry && (
                            <>
                            <div className="popup-group full">
                              <label>Prefix</label>
                              <input
                                className="popup-input-box"
                                value={invoiceConfig.prefix}
                                onChange={(e) => {
                                  let value = e.target.value;
                                  if (value.length > 11) value = value.slice(0, 11);

                                  setInvoiceConfig({ ...invoiceConfig, prefix: value });
                                }}
                              />
                            </div>

                            <div className="popup-group">
                              <label>Zero Padding</label>
                              <input
                                type="number"
                                min="0"
                                max="4"
                                value={invoiceConfig.zero}
                                onChange={(e) => {
                                  let val = Number(e.target.value) || 0;
                                  if (val > 4) val = 4;

                                  setInvoiceConfig({ ...invoiceConfig, zero: val });
                                }}
                              />
                            </div>

                            <div className="popup-group">
                              <label>Start No</label>
                              <input
                                type="number"
                                value={invoiceConfig.start}
                                onChange={(e) => {
                                  let val = Math.max(0, Number(e.target.value) || 0);
                                  setInvoiceConfig({ ...invoiceConfig, start: val });
                                  setCurrentCount(val);
                                }}
                              />
                            </div>
                            </>
                          )}

                          <div className="popup-actions">
                            <button onClick={() => setShowInvoiceSettings(false)}>Cancel</button>
                            <button
                              onClick={() => {
                                if (
                                  !manualEntry && 
                                  (Number(invoiceConfig.zero) || 0) + String(invoiceConfig.start).length > 4
                                ) {
                                  alert("Zero + Start digits cannot exceed 4");
                                  return;
                                }
                                setShowInvoiceSettings(false);
                              }}
                            >
                              Save
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                <div className="type-supply-container">
                  <div className="sale-form-group">
                    <label>Voucher Mode</label>
                    <select value={invoiceType} onChange={(e) => setInvoiceType(e.target.value)}>
                      <option value="item">Item Invoice</option>
                      <option value="accounting">Accounting Invoice</option>
                    </select>
                  </div>
                  <div className="rcm-form-group">
                    <label>RCM Applicable</label>
                    <select onChange={(e) => setRcmApplicable(e.target.value === "yes")}>
                      <option value="no">No</option>
                      <option value="yes">Yes</option>
                    </select>
                  </div>

                  {/* TYPE */}
                  <div className="type-form-group">
                    <label>Type of Supply:</label>
                    <select value={typeOfSupply} onChange={(e) => setTypeOfSupply(e.target.value)}>
                      <option value="Outward">Outward Supply</option>
                      <option value="Export_with_payment">Export with payment</option>
                      <option value="Export_without_payment">Export without payment</option>
                      <option value="SEZ">SEZ supply</option>
                    </select>
                  </div>

                  {/* ECO */}
                  <div className="eco-wrapper" ref={ecoRef}>

                    <label>ECO:</label>

                    <div className="eco-inline">

                      <select
                        value={selectedEco}
                        onChange={(e) => setSelectedEco(e.target.value)}
                      >
                        <option value="">Select ECO</option>
                        {ecoOptions.map((eco, i) => (
                          <option key={i}>{eco}</option>
                        ))}
                      </select>

                      {/* EDIT BUTTON */}
                      <button
                        className="eco-edit-btn"
                        onClick={() => setShowEcoEditor(!showEcoEditor)}
                      >
                        New ECO
                      </button>

                    </div>

                    {/* 🔥 DROPDOWN EDIT PANEL */}
                    {showEcoEditor && (
                      <div className="eco-dropdown-panel">
                        <h4>Create ECO</h4>

                        <div className="eco-form">

                          {/* LEFT */}
                          <div className="eco-left">

                            <div className="eco-field">
                              <label>GSTIN</label>
                              <div className="eco-inline">
                                <input
                                  placeholder="Enter GSTIN"
                                  value={ledger.gstin}
                                  maxLength={15}
                                  onChange={(e) => {
                                    const value = e.target.value.toUpperCase();
                                    setLedger({ ...ledger, gstin: value });
                                    fetchGSTDetails(value);
                                  }}
                                />
                                <span className="eco-auto">
                                  {ledger.gstin.length === 15 ? "Fetching..." : "Auto"}
                                </span>
                              </div>
                            </div>

                            <div className="eco-field">
                              <label>Name</label>
                              <input
                                placeholder="Enter Name"
                                value={ledger.name}
                                onChange={(e) =>
                                  setLedger({ ...ledger, name: e.target.value })
                                }
                              />
                            </div>

                            <div className="eco-field">
                              <label>Address</label>
                              <input
                                placeholder="Address Line 1"
                                value={ledger.address1}
                                onChange={(e) =>
                                  setLedger({ ...ledger, address1: e.target.value })
                                }
                              />
                              <input
                                placeholder="Address Line 2"
                                value={ledger.address2}
                                onChange={(e) =>
                                  setLedger({ ...ledger, address2: e.target.value })
                                }
                              />
                            </div>

                            <div className="eco-field">
                              <label>State</label>
                              <input
                                placeholder="Select State"
                                value={ledger.state}
                                onChange={(e) =>
                                  setLedger({ ...ledger, state: e.target.value })
                                }
                              />
                            </div>

                          </div>

                          {/* RIGHT */}
                          <div className="eco-right">

                            <div className="eco-field">
                              <label>Type</label>
                              <input
                                value={customer?.registration || "E-commerce operator"}
                                readOnly
                              />
                            </div>

                            {/* GROUP DROPDOWN */}
                            <div className="eco-field">
                              <label>Group</label>

                              <div className="eco-select">

                                <div
                                  className="eco-select-box"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setOpenGroupDropdown(!openGroupDropdown);
                                  }}
                                >
                                  {ledger.group || "Sundry Debtors"}
                                </div>

                                {openGroupDropdown && (
                                  <div className="eco-select-dropdown">

                                    {(groupList.length ? groupList : ["Sundry Debtors"]).map((grp) => (
                                      <div
                                        key={grp}
                                        className="eco-option"
                                        onClick={() => {
                                          setLedger({ ...ledger, group: grp });
                                          setOpenGroupDropdown(false);
                                        }}
                                      >
                                        {grp}
                                      </div>
                                    ))}

                                  </div>
                                )}

                              </div>
                            </div>

                            <div className="eco-field">
                              <label>Opening Balance</label>
                              <div className="eco-inline">
                                <input placeholder="0.00" />
                                <select>
                                  <option>Dr</option>
                                  <option>Cr</option>
                                </select>
                              </div>
                            </div>

                          </div>

                        </div>

                        {/* ACTION */}
                        <div className="eco-actions">
                          <button
                            className="eco-cancel"
                            onClick={() => setShowEcoEditor(false)}
                          >
                            Cancel
                          </button>

                          <button
                            className="eco-save"
                            onClick={() => {
                              console.log("ECO DATA:", ledger);

                              const existing = JSON.parse(localStorage.getItem("ecoList")) || [];
                              localStorage.setItem("ecoList", JSON.stringify([...existing, ledger]));

                              setShowEcoEditor(false);
                            }}
                          >
                            Save
                          </button>
                        </div>

                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="sale-grid">
                <div className="sale-form-group">
                  <label>Order Number</label>
                  <select value={orderNo} onChange={(e) => handleOrderChange(e.target.value)}>
                    <option value="">Select</option>
                    {orders.map((o) => (
                      <option key={o.id} value={o.order_number}>
                        {o.order_number}{o.party ? ` - ${typeof o.party === "object" ? o.party.name : ""}` : ""}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="sale-form-group">
                  <label>Order Date</label>
                  <DatePicker
                    selected={orderDate}
                    onChange={(date) => setOrderDate(date)}
                    dateFormat="dd/MM/yyyy"
                    minDate={new Date(new Date().setFullYear(new Date().getFullYear() - 1))} // ✅ last 1 year
                    className="sale-date-input"
                    onChangeRaw={(e) => {
                      if (!e || !e.target) return;
                      let value = e.target.value || "";
                      // allow only numbers + /
                      value = value.replace(/[^0-9/]/g, "");
                      // auto format DD/MM/YYYY
                      if (value.length === 2 || value.length === 5) {
                        if (!value.endsWith("/")) value += "/";
                      }
                      // restrict length
                      if (value.length > 10) {
                        value = value.slice(0, 10);
                      }
                      const parts = value.split("/");
                      // day check
                      if (parts[0] && Number(parts[0]) > 31) parts[0] = "31";
                      // month check
                      if (parts[1] && Number(parts[1]) > 12) parts[1] = "12";
                      // year limit (4 digit)
                      if (parts[2] && parts[2].length > 4) {
                        parts[2] = parts[2].slice(0, 4);
                      }
                      value = parts.join("/");
                      e.target.value = value;
                    }}
                  />
                </div>
                <div className="sale-form-group">
                  <label>Salesman/Agent</label>
                  <div className="eco-inline">
                  <select value={salesman} onChange={(e) => setSalesman(e.target.value)}>
                    <option value="">Select</option>
                    {salesmen.map((s) => (
                      <option key={s.id} value={s.name}>{s.name}</option>
                    ))}
                  </select>
                  <button
                      className="salesman-create-btn"
                      onClick={() => navigate("/Ledger",{state: { defaultGroup: "Sundry Creditors" } })}
                    >
                      New Salesman
                    </button>
                    </div>
                </div>

              </div>

            </div>

            {/* ================= DISPATCH ================= */}
            {invoiceType !== "accounting" && (
            <div className="section-card">
              <div className="dispatch-header">
                <h2 className="sale-disp-section-title">
                  <FaLocationArrow />
                  <span>Dispatch Details</span>
                </h2>
                <div className="dispatch-center-fields">
                  <div className="transporter-box">
                    <label>Transporter Name</label>
                    <div className="transporter-row"> 
                      <select
                        value={dispatch.transporter}
                        onChange={(e) => setDispatch(prev => ({ ...prev, transporter: e.target.value }))}
                      >
                        <option value="">Select</option>
                        {salesmen.map((t) => (
                          <option key={t.id} value={t.name}>{t.name}</option>
                        ))}
                      </select>
                      <button
                        className="transporter-create-btn"
                        onClick={() => navigate("/Ledger", { state: { defaultGroup: "Sundry Creditors" } })}
                      >
                        Create
                      </button>
                    </div>
                  </div>
                  <div className="gstin-container">
                    <label>Transport GSTIN</label>
                    <input 
                      value={gstin}
                      onChange={handleGSTChange}
                      placeholder="Transport GSTIN"
                    />

                    {/* LOADING */}
                    {gstLoading && <div className="gst-status">Validating...</div>}

                    {/* ERROR */}
                    {gstError && <div className="gst-error">{gstError}</div>}

                    {/* SUCCESS */}
                    {gstData && (
                      <div className="gst-result-box">
                        <p><strong>{gstData.company_name}</strong></p>
                        <p>{gstData.state}</p>
                        <p>Status: {gstData.status}</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="dispatch-grid">
                <div className="dis-container">
                  <label>E-Way Bill No</label>
                  <input placeholder="E-Way No" value={dispatch.ewayBill} onChange={(e) => setDispatch(prev => ({ ...prev, ewayBill: e.target.value }))} />
                </div>
                <div className="veh-container">
                  <label>Vehicle No</label>
                  <input placeholder="Vehicle No" value={dispatch.vehicle} onChange={(e) => setDispatch(prev => ({ ...prev, vehicle: e.target.value }))} />
                </div>
                <div className="LR">
                  <label>LR-RR No</label>
                  <input placeholder="LR-RR No" value={dispatch.lr} onChange={(e) => setDispatch(prev => ({ ...prev, lr: e.target.value }))} />
                </div>
                <div className="date-container">
                  <label>Date</label>
                  <DatePicker
                    selected={dispatchDate}
                    onChange={(date) => setDispatchDate(date)}
                    dateFormat="dd/MM/yyyy"
                    minDate={new Date(new Date().setFullYear(new Date().getFullYear() - 1))} // ✅ last 1 year
                    className="sale-date-input"
                    onChangeRaw={(e) => {
                      if (!e || !e.target) return;
                      let value = e.target.value || "";
                      // allow only numbers + /
                      value = value.replace(/[^0-9/]/g, "");
                      // auto format DD/MM/YYYY
                      if (value.length === 2 || value.length === 5) {
                        if (!value.endsWith("/")) value += "/";
                      }
                      // restrict length
                      if (value.length > 10) {
                        value = value.slice(0, 10);
                      }
                      const parts = value.split("/");
                      // day check
                      if (parts[0] && Number(parts[0]) > 31) parts[0] = "31";
                      // month check
                      if (parts[1] && Number(parts[1]) > 12) parts[1] = "12";
                      // year limit (4 digit)
                      if (parts[2] && parts[2].length > 4) {
                        parts[2] = parts[2].slice(0, 4);
                      }
                      value = parts.join("/");
                      e.target.value = value;
                    }}
                    />
                  </div>
                
                {/* 🔥 EXPORT / SEZ EXTRA FIELDS */}
                  {(typeOfSupply === "Export_with_payment" || 
                    typeOfSupply === "Export_without_payment" ||
                    typeOfSupply === "SEZ") && (
                    
                    <>
                    <div className="port">
                      <label>Port of Export</label>
                      <select>
                        <option>Select</option>
                        <option>INDEA6 - AACHIVS SEZ/NOIDA </option>
                      </select>
                      {/* <input placeholder="Port No." /> */}
                    </div>
                    {/* <div className="country">
                      <label>Country Name</label>
                      <input placeholder="Country" />
                    </div> */}
                    <div className="ship-bill">
                      <label>Shipping Bill No</label>
                      <input placeholder="Shipping Bill No" />
                    </div>
                    <div className="ship-bill">
                      <label>Shipping date</label>
                       <DatePicker
                    selected={shippingDate}
                    onChange={(date) => setshippingDate(date)}
                    dateFormat="dd/MM/yyyy"
                    minDate={new Date(new Date().setFullYear(new Date().getFullYear() - 1))} // ✅ last 1 year
                    className="date-input"
                    onChangeRaw={(e) => {
                      if (!e || !e.target) return;
                      let value = e.target.value || "";
                      // allow only numbers + /
                      value = value.replace(/[^0-9/]/g, "");
                      // auto format DD/MM/YYYY
                      if (value.length === 2 || value.length === 5) {
                        if (!value.endsWith("/")) value += "/";
                      }
                      // restrict length
                      if (value.length > 10) {
                        value = value.slice(0, 10);
                      }
                      const parts = value.split("/");
                      // day check
                      if (parts[0] && Number(parts[0]) > 31) parts[0] = "31";
                      // month check
                      if (parts[1] && Number(parts[1]) > 12) parts[1] = "12";
                      // year limit (4 digit)
                      if (parts[2] && parts[2].length > 4) {
                        parts[2] = parts[2].slice(0, 4);
                      }
                      value = parts.join("/");
                      e.target.value = value;
                    }}
                    />
                    </div>
                      
                      {/* ONLY FOR EXPORT WITHOUT PAYMENT */}
                      {typeOfSupply === "Export_without_payment" && (
                        <div className="LUT">
                          <label>LUT / Bond No</label>
                          <input placeholder="LUT / Bond No" />
                        </div>
                      )}
                    </>
                  )}
              </div>
            </div>
            )}
            {/* ================= CUSTOMER ================= */}
            <div className="section-card">
              <h2 className="sale-disp-section-title">
                <FaBuilding />
                <span>Customer Details</span>
              </h2>
              <div className="search-customer">
                <label>Search Customer Name</label>
                <div className="sale-search-box">
                  <div className="sale-search-input-wrapper">
                    <FaSearch className="sale-search-icon" />
                    <input
                      type="text"
                      placeholder="Search customer..."
                      value={customerSearch}
                      onChange={(e) => {
                        setCustomerSearch(e.target.value);
                        setShowCustomerDropdown(true);
                      }}
                      onFocus={() => setShowCustomerDropdown(true)}
                    />
                  </div>
                  <button
                    className="new-customer-btn"
                    onClick={() => setShowCustomerPopup(true)}
                  >
                    New Customer
                  </button>
                  {showCustomerDropdown && (
                    <div className="customer-search-dropdown">
                      {filteredCustomers.length === 0 && (
                        <div className="customer-search-empty">No customers found</div>
                      )}
                      {filteredCustomers.map((cust) => (
                        <div
                          key={cust.id}
                          className="customer-search-option"
                          onClick={() => selectCustomer(cust)}
                        >
                          <div className="customer-search-name">{cust.name}</div>
                          <div className="customer-search-gstin">{cust.gstin || ""}</div>
                        </div>
                      ))}
                    </div>
                  )}
                 {showCustomerPopup && (
                  <div
                    className="cust-overlay"
                    onClick={() => setShowCustomerPopup(false)}   // 🔥 outside click close
                  >

                    <div
                      className="cust-popup"
                      onClick={(e) => e.stopPropagation()}        // 🔥 prevent inside click close
                    >

                      {/* HEADER */}
                      <div className="cust-header">
                        <h3>Add New Customer</h3>

                        <button
                          className="cust-close-btn"
                          onClick={() => setShowCustomerPopup(false)}
                        >
                          ✕
                        </button>
                      </div>

                      <div className="cust-form-wrapper">

                        {/* LEFT */}
                        <div className="cust-left">

                          {/* GST ROW */}
                          <div className="cust-gst-row">
                            <input
                              className="cust-input"
                              placeholder="GSTIN / URP"
                              onChange={(e)=>setCustomer({...customer,gstin:e.target.value})}
                            />

                            <button className="cust-get-btn" onClick={fetchGstForCustomer}>Get Data</button>
                          </div>

                          <input className="cust-input" placeholder="Party Name"
                            onChange={(e)=>setCustomer({...customer,name:e.target.value})}
                          />

                          <input className="cust-input" placeholder="Billing Address 1"
                            onChange={(e)=>setCustomer({...customer,address1:e.target.value})}
                          />

                          <input className="cust-input" placeholder="Billing Address 2"
                            onChange={(e)=>setCustomer({...customer,address2:e.target.value})}
                          />

                          <input className="cust-input" placeholder="Pin"
                            onChange={(e)=>setCustomer({...customer,pin:e.target.value})}
                          />

                          <div className="cust-select">

                          <div
                            className="cust-select-box"
                            onClick={() => setOpenStateDropdown(!openStateDropdown)}
                          >
                            {selectedState || "Select State"}
                            <span className="arrow">▼</span>
                          </div>

                          {openStateDropdown && (
                            <div className="cust-select-dropdown">

                              {states.map((state) => (
                                <div
                                  key={state}
                                  className="cust-option"
                                  onClick={() => {
                                    setSelectedState(state);
                                    setCustomer({...customer, state});
                                    setOpenStateDropdown(false);
                                  }}
                                >
                                  {state}
                                </div>
                              ))}

                            </div>
                          )}

                        </div>

                          <input className="cust-input" placeholder="Contact No"
                            onChange={(e)=>setCustomer({...customer,contact:e.target.value})}
                          />

                          <input className="cust-input" placeholder="Email ID"
                            onChange={(e)=>setCustomer({...customer,email:e.target.value})}
                          />

                          <input className="cust-input" placeholder="PAN"
                            onChange={(e)=>setCustomer({...customer,pan:e.target.value})}
                          />

                          <div className="cust-row">
                            <input className="cust-input" placeholder="Opening Balance"
                              onChange={(e)=>setCustomer({...customer,balance:e.target.value})}
                            />

                            <select className="cust-input"
                              onChange={(e)=>setCustomer({...customer,drcr:e.target.value})}
                            >
                              <option>Dr</option>
                              <option>Cr</option>
                            </select>
                          </div>

                        </div>

                        {/* RIGHT */}
                        <div className="cust-right">

                          <label>Registration Type</label>

                          <select className="sale-cust-input"
                            onChange={(e)=>setCustomer({...customer,registration:e.target.value})}
                          >
                            <option>Select</option>
                            <option>Composition</option>
                            <option>Regular</option>
                            <option>Unregistered / Consumer</option>
                            <option>Government Entity / TDS</option>
                            <option>Regular - SEZ</option>
                            <option>Regular - Exports (EOU)</option>
                            <option>E-Commerce Operator</option>
                            <option>Input Service Distributor</option>
                            <option>Embassy / UN Body</option>
                            <option>Non Resident Taxpayer</option>
                          </select>

                        </div>

                      </div>

                      {/* ACTIONS */}
                      <div className="cust-actions">
                        <button className="cust-save-btn" onClick={saveCustomer}>Save Customer</button>
                      </div>

                    </div>

                  </div>
                )}
                </div>
              </div>
              {/* Billed To and Shipped To */}
              <div className="customer-details-container">         
                {/* Billed To */}
                <div className="customer-card">
                  <div className="customer-card-header">
                    <h3 className="customer-card-title">
                      <FaUniversity />
                      Billed To:
                    </h3>
                  </div>
                  
                  {editBilled ? (
                    <div className="customer-edit-form">
                      <input 
                        type="text" 
                        value={billedTo.name}
                        onChange={(e) => setBilledTo({...billedTo, name: e.target.value})}
                        placeholder="Company Name"
                      />
                      <input 
                        type="text" 
                        value={billedTo.address}
                        onChange={(e) => setBilledTo({...billedTo, address: e.target.value})}
                        placeholder="Address"
                      />
                      <input 
                        type="text" 
                        value={billedTo.city}
                        onChange={(e) => setBilledTo({...billedTo, city: e.target.value})}
                        placeholder="City"
                      />
                      <div className="form-row">
                        <input 
                          type="text" 
                          value={billedTo.contact}
                          onChange={(e) => setBilledTo({...billedTo, contact: e.target.value})}
                          placeholder="Contact Person"
                        />
                        <input 
                          type="text" 
                          value={billedTo.mobile}
                          onChange={(e) => setBilledTo({...billedTo, mobile: e.target.value})}
                          placeholder="Mobile"
                        />
                      </div>
                      <div className="form-row">
                        <input 
                          type="text" 
                          value={billedTo.pan}
                          onChange={(e) => setBilledTo({...billedTo, pan: e.target.value})}
                          placeholder="PAN"
                        />
                        <input 
                          type="text" 
                          value={billedTo.gstin}
                          onChange={(e) => setBilledTo({...billedTo, gstin: e.target.value})}
                          placeholder="GSTIN"
                        />
                      </div>
                      <input 
                        type="text" 
                        value={billedTo.pos}
                        onChange={(e) => setBilledTo({...billedTo, pos: e.target.value})}
                        placeholder="Place of Supply"
                      />
                    </div>
                  ) : (
                    <div className="customer-details">
                      <p className="customer-name">{billedTo.name}</p>
                      <p className="customer-address">{billedTo.address}</p>
                      <p className="customer-address">{billedTo.city}</p>
                      <p className="customer-contact">
                        Contact: {billedTo.contact} (Mobile - {billedTo.mobile})
                      </p>
                      <p className="customer-tax">
                        PAN: {billedTo.pan}
                      </p>
                      <p className="customer-tax">
                        GSTIN: {billedTo.gstin}
                      </p>
                      <p className="customer-pos">
                        Place of Supply: {billedTo.pos}
                      </p>
                    </div>
                  )}
                </div>

                {/* Shipped To */}
                {invoiceType !== "accounting" && (
                <div className="customer-card">
                  <div className="customer-card-header">
                    <h3 className="customer-card-title">
                      <FaTruck />
                      Shipped To:
                    </h3>
                    <button 
                      className="sales-edit-btn"
                      onClick={() => setEditShipped(!editShipped)}
                    >
                        <FaPen />
                      {editShipped ? 'Save' : 'Edit'}
                    </button>
                  </div>
                  
                  {editShipped ? (
                    <div className="customer-edit-form">
                      <input 
                        type="text" 
                        value={shippedTo.name}
                        onChange={(e) => setShippedTo({...shippedTo, name: e.target.value})}
                        placeholder="Company Name"
                      />
                      <input 
                        type="text" 
                        value={shippedTo.address}
                        onChange={(e) => setShippedTo({...shippedTo, address: e.target.value})}
                        placeholder="Address"
                      />
                      <input 
                        type="text" 
                        value={shippedTo.city}
                        onChange={(e) => setShippedTo({...shippedTo, city: e.target.value})}
                        placeholder="City"
                      />
                      <div className="form-row">
                        <input 
                          type="text" 
                          value={shippedTo.contact}
                          onChange={(e) => setShippedTo({...shippedTo, contact: e.target.value})}
                          placeholder="Contact Person"
                        />
                        <input 
                          type="text" 
                          value={shippedTo.mobile}
                          onChange={(e) => setShippedTo({...shippedTo, mobile: e.target.value})}
                          placeholder="Mobile"
                        />
                      </div>
                      <div className="form-row">
                        <input 
                          type="text" 
                          value={shippedTo.pan}
                          onChange={(e) => setShippedTo({...shippedTo, pan: e.target.value})}
                          placeholder="PAN"
                        />
                        <input 
                          type="text" 
                          value={shippedTo.gstin}
                          onChange={(e) => setShippedTo({...shippedTo, gstin: e.target.value})}
                          placeholder="GSTIN"
                        />
                      </div>
                      <input 
                        type="text" 
                        value={shippedTo.pos}
                        onChange={(e) => setShippedTo({...shippedTo, pos: e.target.value})}
                        placeholder="Place of Supply"
                      />
                    </div>
                  ) : (
                    <div className="customer-details">
                      <p className="customer-name">{shippedTo.name}</p>
                      <p className="customer-address">{shippedTo.address}</p>
                      <p className="customer-address">{shippedTo.city}</p>
                      <p className="customer-contact">
                        Contact: {shippedTo.contact} (Mobile - {shippedTo.mobile})
                      </p>
                      <p className="customer-tax">
                        PAN: {shippedTo.pan}
                      </p>
                      <p className="customer-tax">
                        GSTIN: {shippedTo.gstin}
                      </p>
                      <p className="customer-pos">
                        Place of Supply: {shippedTo.pos}
                      </p>
                    </div>
                  )}
                </div>
                )}
              </div>
            </div>

            {/* ================= ITEMS ================= */}
            <div className="section-card">
              <h2 className="sale-disp-section-title">
                <FaBoxOpen />
                <span>Items</span>
              </h2>

              {invoiceType === "item" ? (
                <datalist id="items-datalist">
                  {itemsList.map((it) => (
                    <option key={it.id} value={it.name} />
                  ))}
                </datalist>
              ) : null}
              {invoiceType === "item" ? (
                <table className="items-table">
                  <thead>
                    <tr>
                      <th>Action</th> 
                      <th>S.L</th>
                      <th>Description</th>
                      <th>HSN</th>
                      <th>Qty</th>
                      <th>Rate</th>
                      <th>Discount</th>
                      <th>Tax</th>
                      <th>Amount</th>
                    </tr>
                  </thead>

                  <tbody>
                    {items.map((item, i) => {
                      const qty = Number(item.qty) || 0;
                      const rate = Number(item.rate) || 0;
                      const discount = Number(item.discount) || 0;
                      const tax = Number(item.tax) || 0;

                      const base = qty * rate - discount;

                      const amount = rcmApplicable
                        ? base   // 🚨 GST disabled
                        : base + (base * tax) / 100;

                      return (
                        <tr key={i}>
                          <td>
                            <button
                              className="sale-delete-btn"
                              onClick={() => deleteRow(i)}
                            >
                              <FaTrash />
                            </button>
                          </td>
                          <td>{i + 1}</td>
                          <td><input list="items-datalist" value={item.description} onChange={(e) => {
                            const d = [...items];
                            const val = e.target.value;
                            d[i].description = val;
                            const match = itemsList.find((it) => it.name === val);
                            if (match) {
                              d[i].itemId = match.id;
                              d[i].hsn = match.hsn_code || "";
                            } else {
                              d[i].itemId = null;
                            }
                            setItems(d);
                          }} /></td>

                          <td><input value={item.hsn} onChange={(e) => {
                            const d = [...items]; d[i].hsn = e.target.value; setItems(d);
                          }} /></td>

                          <td><input type="number" onChange={(e) => {
                            const d = [...items]; d[i].qty = e.target.value; setItems(d);
                          }} /></td>

                          <td><input type="number" onChange={(e) => {
                            const d = [...items]; d[i].rate = e.target.value; setItems(d);
                          }} /></td>

                          <td><input type="number" onChange={(e) => {
                            const d = [...items]; d[i].discount = e.target.value; setItems(d);
                          }} /></td>

                          <td>
                            <select
                              disabled={rcmApplicable}   // 🚨 disable tax
                              onChange={(e) => {
                                const d = [...items]; d[i].tax = e.target.value; setItems(d);
                              }}
                            >
                              <option value="0">0%</option>
                              <option value="5">5%</option>
                              <option value="12">12%</option>
                              <option value="18">18%</option>
                            </select>
                          </td>

                          <td><input value={amount.toFixed(2)} readOnly /></td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>

              ) : (
                /* 🔥 ACCOUNTING INVOICE MODE */
                <table className="items-table">
                  <thead>
                    <tr>
                      <th>Action</th> 
                      <th>Ledger</th>
                      <th>Tax Rate</th>
                      <th>Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {items.map((item, i) => (
                      <tr key={i}>
                        <td>
                          <button
                            className="delete-btn"
                            onClick={() => deleteRow(i)}
                          >
                            <FaTrash />
                          </button>
                        </td>

                        {/* Ledger */}
                        <td>
                          <input
                            placeholder="Purchase A/c"
                            onChange={(e) => {
                              const d = [...items];
                              d[i].ledger = e.target.value;
                              setItems(d);
                            }}
                          />
                        </td>

                        {/* Tax */}
                        <td>
                          <select
                            disabled={rcmApplicable}
                            value={rcmApplicable ? 0 : item.tax || 0}
                            onChange={(e) => {
                              const d = [...items];
                              d[i].tax = Number(e.target.value);
                              setItems(d);
                            }}
                          >
                            <option value="0">0%</option>
                            <option value="5">5%</option>
                            <option value="12">12%</option>
                            <option value="18">18%</option>
                          </select>
                        </td>

                        {/* Amount (MAIN FIX) */}
                        <td>
                          <input
                            type="number"
                            value={item.amount || ""}
                            onChange={(e) => {
                              const d = [...items];
                              d[i].amount = Number(e.target.value);   // ✅ IMPORTANT
                              setItems(d);
                            }}
                          />
                        </td>

                      </tr>
                    ))}
                  </tbody>
                </table>
              )}

              <button className="sale-add-item-btn" onClick={addRow}>
                + Add Item
              </button>
            </div>

            {/* ================= SUMMARY ================= */}
            <div className="tax-summary-box">
              {(() => {

                let sub = 0;
                let gst = 0;

                if (invoiceType === "item") {
                  // ✅ NORMAL ITEM LOGIC
                  // sub = items.reduce((s, i) => s + (i.qty * i.rate || 0), 0);
                  sub = items.reduce((s, i) => {
                    const qty = Number(i.qty) || 0;
                    const rate = Number(i.rate) || 0;
                    const discount = Number(i.discount) || 0;
                    return s + (qty * rate - discount);
                  }, 0);

                  gst = items.reduce((s, i) => {
                    const base = (i.qty * i.rate || 0) - (i.discount || 0);
                    return rcmApplicable ? s : s + (base * (i.tax || 0)) / 100;
                  }, 0);

                } else {
                  // 🔥 ACCOUNTING MODE LOGIC
                  sub = items.reduce((s, i) => s + (Number(i.amount) || 0), 0);

                  gst = items.reduce((s, i) => {
                    const amt = Number(i.amount) || 0;
                    return rcmApplicable ? s : s + (amt * (i.tax || 0)) / 100;
                  }, 0);
                }

                let igst = 0;
                let cgst = 0;
                let sgst = 0;

                if (typeOfSupply === "Outward") {
                  cgst = gst / 2;
                  sgst = gst / 2;
                }

                if (typeOfSupply === "Export_with_payment") {
                  igst = gst;
                }

                if (typeOfSupply === "Export_without_payment") {
                  igst = 0;
                  cgst = 0;
                  sgst = 0;
                }

                if (typeOfSupply === "SEZ") {
                  igst = gst; // can refine later
                }

                const cess = 0;
                const tcs = 0;

                const totalBeforeRound = sub + igst + cgst + sgst + cess + tcs;

                const roundOff = Math.round(totalBeforeRound) - totalBeforeRound;

                const grandTotal = totalBeforeRound + roundOff;

                return (
                  <>
                    <div className="sale-tax-summary">
                      <div className="sale-summary-row">
                        <span>Sub Total:</span>
                        <span>₹ {sub.toFixed(2)}</span>
                      </div>
                      <div className="sale-summary-row">
                        <span>IGST:</span>
                        <span>₹ {igst.toFixed(2)}</span>
                      </div>

                      <div className="sale-summary-row">
                        <span>CGST:</span>
                        <span>₹ {cgst.toFixed(2)}</span>
                      </div>
                      <div className="sale-summary-row">
                        <span>SGST:</span>
                        <span>₹ {sgst.toFixed(2)}</span>
                      </div>
                      <div className="sale-summary-row">
                        <span>CESS:</span>
                        <span>₹ {cess.toFixed(2)}</span>
                      </div>
                      <div className="sale-summary-row">
                        <span>TCS:</span>
                        <span>₹ {tcs.toFixed(2)}</span>
                      </div>
                      <div className="sale-summary-row">
                        <span>Round Off:</span>
                        <span>₹ {roundOff.toFixed(2)}</span>
                      </div>
                      <div className="sale-summary-row grand-total">
                        <span>Grand Total:</span>
                        <span>₹ {grandTotal.toFixed(2)}</span>
                      </div>
                    </div>
                  </>
                );
              })()}
            </div>
            {/* ================= ACTIONS ================= */}
            <div className="sale-footer-actions">
              <button className="sale-save-btn" onClick={() => handleSave("save")}>
                <FaSave />
                Save
              </button>

              <button className="sale-save-send-btn" onClick={() => handleSave("send")}>
                <FaPaperPlane />
                Save & Send
              </button>

              <button className="sale-print-btn" onClick={() => window.print()}>
                <FaPrint />
                Print
              </button>

              <button className="sale-cancel-btn" onClick={resetForm}>
                <FaTimes />
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }